module.exports = __webpack_public_path__ + "img/barraFondoMobile.b363a260.svg";